import { Injectable } from '@angular/core';

export enum LogLevel {
  ERROR = 1,
  WARNING = 2,
  INFO = 3,
  LOG = 4,
  DEBUG = 5
}


@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  public logLevel: number;

  private logLevelByComponent: { [id: string]: number } = {};

  protected logLevelCss: { [key: number]: string } = {};

  constructor() {
    this.logLevel = LogLevel.DEBUG;

    // Initalize log level colours.
    this.logLevelCss[LogLevel.ERROR] = 'color: #F00';
    this.logLevelCss[LogLevel.WARNING] = 'color: #F80';
    this.logLevelCss[LogLevel.INFO] = 'color: #0A0';
    this.logLevelCss[LogLevel.LOG] = 'color: #088';
    this.logLevelCss[LogLevel.DEBUG] = 'color: #AAA';

    window['logger'] = this;
  }

  private isLoggable(msgLogLevel: LogLevel, component: string): boolean {
    var rc: boolean;

    if (typeof (msgLogLevel) === 'undefined') {
      msgLogLevel = LogLevel.INFO;
    }

    if (typeof (this.logLevelByComponent[component]) !== 'undefined') {
      rc = this.logLevelByComponent[component] >= msgLogLevel;
    }
    else {
      rc = this.logLevel >= msgLogLevel;
    }

    return rc;
  }

  private tryToLog(msgLogLevel: LogLevel, logLevelLabel: string, component: string, ...data: any[]) {
    if (this.isLoggable(msgLogLevel, component)) {
      this.doLog('%c[' + component + ' ' + logLevelLabel + ']', this.logLevelCss[msgLogLevel], ...data);
    }
  }

  private doLog(label: string, ...data: any[]) {
  }

  public setComponentLogLevel(component: string, newLogLevel: LogLevel) {
    this.logLevelByComponent[component] = newLogLevel;
  }

  public error(component: string, ...data: any[]) {
    this.tryToLog(LogLevel.ERROR, 'ERROR', component, ...data);
  }

  public warning(component: string, ...data: any[]) {
    this.tryToLog(LogLevel.WARNING, 'WARNING', component, ...data);
  }

  public info(component: string, ...data: any[]) {
    this.tryToLog(LogLevel.INFO, 'INFO', component, ...data);
  }

  public log(component: string, ...data: any[]) {
    this.tryToLog(LogLevel.LOG, 'LOG', component, ...data);
  }

  public debug(component: string, ...data: any[]) {
    this.tryToLog(LogLevel.DEBUG, 'DEBUG', component, ...data);
  }
}

